import styled from 'styled-components';

const MessageList = styled.div`
padding-bottom: 56px;`;

export default MessageList;
